import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import letterFadeInStartGif from '../../../assets/images/transitions/letterFadeInStart.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_FADE_IN_START = 'letterFadeInStart';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterFadeInStartPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_FADE_IN_START,

  // A human friendly name for the preset.
  humanName: 'Letter - Fade In From Start',

  // A preview of the transition.
  gif: letterFadeInStartGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'letter.opacity': {
      time: {
        end: 'start.403',
        start: 'start.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        0,
        1
      ],
      stagger: 70,
      staggerDuration: false,
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_FADE_IN_START,
    options: {},
  },
};

letterFadeInStartPresetDetails.template.options = lodash.cloneDeep(letterFadeInStartPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_FADE_IN_START;

// This defines the value of the presets object.
export default letterFadeInStartPresetDetails;
